import React from 'react';
import { Download } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Dashboard } from './Dashboard';
import { clients } from '../lib/data';
export function ClientDashboard() {
  const client = clients[0];
  return <div className="min-h-screen bg-background flex flex-col" data-id="element-743">
      {/* Client Header */}
      <header className="py-3 md:h-16 border-b border-border bg-card flex flex-col md:flex-row md:items-center justify-between px-4 md:px-8 flex-shrink-0 gap-3 md:gap-0" data-id="element-744">
        <div className="flex items-center gap-3 md:gap-4" data-id="element-745">
          <img src={client.logo} alt={client.name} className="max-w-[100px] max-h-[32px] object-contain object-left flex-shrink-0" data-id="element-746" />
          <div data-id="element-747">
            <h1 className="font-semibold text-sm" data-id="element-748">{client.name}</h1>
            <p className="text-[10px] md:text-xs text-muted-foreground" data-id="element-749">
              Rassegna Stampa Analytics
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between md:justify-end gap-4 w-full md:w-auto" data-id="element-750">
          <span className="text-xs md:text-sm text-muted-foreground" data-id="element-751">
            Aprile 2025
          </span>
          <Button className="bg-accent hover:bg-accent/90 text-accent-foreground h-10 md:h-11 text-xs md:text-sm rounded-full" data-id="element-752">
            <Download className="h-3 w-3 md:h-4 md:w-4 mr-1.5 md:mr-2" data-id="element-753" />
            Scarica Report PDF
          </Button>
        </div>
      </header>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-754">
        <div data-id="element-755">
          <h1 className="text-2xl md:text-3xl font-semibold tracking-tight" data-id="element-756">
            {client.name}
          </h1>
        </div>
        <Button className="h-10 md:h-11 text-xs md:text-sm rounded-full" data-id="element-757">
          <Download className="h-4 w-4 mr-2" data-id="element-758" />
          Scarica Report
        </Button>
      </div>

      {/* Main Content - Reusing Dashboard but without sidebar */}
      <main className="flex-1 overflow-auto" data-id="element-759">
        <Dashboard data-id="element-760" />
      </main>
    </div>;
}